import { SearchActionTypes, SearchActions } from '../actions/ActionTypes';
import { SearchState, initialState } from '../state/SearchState';
import { ContentType } from '../models/ContentType';
import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentTypeFilterValue, ContentTypeFilterAllOption } from '../models/ContentTypeFilterValue';
import { getSortSelectionFromUrl } from '../utils/SortUtils';
import { SearchStatus } from '../components/SearchResultPage';
import { LocalStorageService } from '../services/LocalStorageService';
import { DisplayBy } from '../models/DisplaySelection';

export const searchReducer = (previousState: SearchState = initialState, action: SearchActions): SearchState => {
  switch (action.type) {
    case SearchActionTypes.PERFORM_SEARCH:
      return { ...previousState, status: SearchStatus.isSearching, searchTerm: action.searchTerm };
    case SearchActionTypes.SEARCH_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const totalCount =
        action.results && action.results.map
          ? Object.entries(action.results.map).reduce((p, [, value]) => (p += value ? value.totalCount : 0), 0)
          : 0;
      return {
        ...previousState,
        status: SearchStatus.searchComplete,
        totalCount: totalCount,
        mixedContentType: { ...previousState.mixedContentType, searchResult: action.results },
      };
    case SearchActionTypes.SEARCH_SUCCESS_WITH_METADATA:
      // eslint-disable-next-line no-case-declarations
      const newState = {
        ...previousState,
      };

      if (previousState.mixedContentType.searchResult) {
        newState.mixedContentType.searchResult = { ...previousState.mixedContentType.searchResult };
        newState.mixedContentType.searchResult.map[action.contentType].list = action.data;
      }

      return newState;
    case SearchActionTypes.SEARCH_FAILED:
      return {
        ...previousState,
        status: SearchStatus.hasError,
        totalCount: 0,
      };
    case SearchActionTypes.CHANGE_CONTENT_BY_URL_PATH:
      // eslint-disable-next-line no-case-declarations
      let contentTypeFilterValue: ContentTypeFilterValue = ContentTypeFilterAllOption;
      for (const currentContentType in ContentDefinitions) {
        if (action.urlPath === ContentDefinitions[currentContentType as ContentType].getPath(action.urls)) {
          contentTypeFilterValue = currentContentType as ContentTypeFilterValue;
        }
      }
      // if we just changed the content type dont update the sortBy, since we want to persist the sort when switching content types
      if (previousState.selectedContentTypeFilterValue !== contentTypeFilterValue) {
        return {
          ...previousState,
          searchTerm: action.searchTerm,
          selectedContentTypeFilterValue: contentTypeFilterValue,
        };
      } else {
        return {
          ...previousState,
          searchTerm: action.searchTerm,
          selectedContentTypeFilterValue: contentTypeFilterValue,
          sortBy: getSortSelectionFromUrl(contentTypeFilterValue),
        };
      }
    case SearchActionTypes.ORDER_BY:
      return {
        ...previousState,
        sortBy: action.sortSelection,
      };
    case SearchActionTypes.SET_DISPLAY_MODE:
      LocalStorageService.instance.setLocalDisplayView(action.displaySelection);
      return {
        ...previousState,
        displayBy: action.displaySelection,
      };
    case SearchActionTypes.LOAD_INITIAL_DISPLAY_MODE:
      // eslint-disable-next-line no-case-declarations
      const display = LocalStorageService.instance.getLocalDisplayView(LocalStorageService.instance.getLocalDisplayKey());
      return {
        ...previousState,
        displayBy: display
          ? display === DisplayBy.getMixedViewDisplaySelection().name
            ? DisplayBy.getMixedViewDisplaySelection()
            : DisplayBy.getListViewDisplaySelection()
          : DisplayBy.getMixedViewDisplaySelection(),
      };
    case SearchActionTypes.CONTENT_FAVORITE_ADDED_ACTION:
      // eslint-disable-next-line no-case-declarations
      const addedFavoriteState = {
        ...previousState,
      };
      if (previousState.mixedContentType.searchResult) {
        previousState.mixedContentType.searchResult.map[action.item.contentType].list.forEach((item, index) => {
          if (action.item.id === item.id) {
            if (addedFavoriteState.mixedContentType.searchResult) {
              const list = addedFavoriteState.mixedContentType.searchResult.map[action.item.contentType].list;
              list[index] = { ...list[index], favorite: true };
            }
          }
        });
      }
      return addedFavoriteState;
    case SearchActionTypes.CONTENT_FAVORITE_REMOVED_ACTION:
      // eslint-disable-next-line no-case-declarations
      const removeFavoriteState = {
        ...previousState,
      };
      if (previousState.mixedContentType.searchResult) {
        previousState.mixedContentType.searchResult.map[action.item.contentType].list.forEach((item, index) => {
          if (action.item.id === item.id) {
            if (removeFavoriteState.mixedContentType.searchResult) {
              const list = removeFavoriteState.mixedContentType.searchResult.map[action.item.contentType].list;
              list[index] = { ...list[index], favorite: false };
            }
          }
        });
      }
      return removeFavoriteState;
    default:
      return previousState;
  }
};
